/**
 * Module-level prefetch cache for swipe navigation.
 * Data survives React re-renders (module singleton).
 */
const cache = {};

export function prefetchUrl(url) {
    if (cache[url] !== undefined) return; // already fetched or in flight
    cache[url] = null; // mark in-flight
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
            try { cache[url] = JSON.parse(this.responseText); } catch (_) {}
        }
    };
    xhr.send();
}

export function getCached(url) {
    const val = cache[url];
    return val && val !== null ? val : null;
}

export function clearCache(url) {
    delete cache[url];
}
